import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    editModalSegmentedTaggedCampaign,
    editModalSegmentsRequest,
    setModalSelectedGroup,
    toggleTagsGroupModal,
} from './segments-modal.state';

export const withSegmentsModal = connect(
    state => ({
        isTagsGroupModalOpen: state.segments.modal.isTagsGroupModalOpen,
        modalSelectedGroup: state.segments.modal.modalSelectedGroup,
    }),
    dispatch => bindActionCreators({
        toggleTagsGroupModal,
        setModalSelectedGroup,
        editModalSegmentedTaggedCampaign,
        editModalSegmentsRequest,
    }, dispatch),
);
